<template>
    <PageWapper>
        <BannerProduct />
        <CaseProduct />
        <Audition />
    </PageWapper>
</template>

<script>
import PageWapper from "@/components/PageWapper.vue";
import BannerProduct from "./components/BannerProduct.vue";
import CaseProduct from "./components/CaseProduct.vue";
import Audition from "./components/Audition.vue";

export default {
    components: { PageWapper, BannerProduct, CaseProduct, Audition },
    data: () => ({}),
    created() {},
    methods: {},
};
</script>
